/**
 * AddressFields — riusabile per Sede Legale e Sedi Operative.
 * 4 campi strutturati: indirizzo, cap, comune, provincia (dropdown 102 sigle).
 *
 * value shape:  { indirizzo, cap, comune, provincia }
 * onChange:     (nextValue: partial) => void  (merge-shallow)
 */
import React from "react";
import { Input } from "./ui/input";
import { Label } from "./ui/label";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { PROVINCE_IT, isValidCAP } from "../lib/provinces";

export function AddressFields({ value = {}, onChange, testidPrefix = "addr" }) {
  const patch = (key, v) => onChange({ ...value, [key]: v });
  const capOk = isValidCAP(value.cap || "");

  return (
    <div className="grid grid-cols-1 sm:grid-cols-12 gap-3">
      <div className="sm:col-span-7">
        <Label className="text-xs font-medium text-slate-600">
          Indirizzo (via e n. civico)
        </Label>
        <Input
          value={value.indirizzo || ""}
          onChange={(e) => patch("indirizzo", e.target.value)}
          className="mt-1 h-9 rounded-md border-slate-200 bg-white"
          placeholder="Via Roma 12"
          data-testid={`${testidPrefix}-indirizzo`}
        />
      </div>
      <div className="sm:col-span-2">
        <Label className="text-xs font-medium text-slate-600">CAP</Label>
        <Input
          value={value.cap || ""}
          onChange={(e) =>
            patch("cap", e.target.value.replace(/[^\d]/g, "").slice(0, 5))
          }
          className={`mt-1 h-9 rounded-md bg-white ${
            capOk ? "border-slate-200" : "border-red-400"
          }`}
          placeholder="20121"
          inputMode="numeric"
          maxLength={5}
          data-testid={`${testidPrefix}-cap`}
        />
        {!capOk && (
          <p className="mt-1 text-[10px] text-red-600">
            CAP deve essere di 5 cifre
          </p>
        )}
      </div>
      <div className="sm:col-span-3">
        <Label className="text-xs font-medium text-slate-600">Comune</Label>
        <Input
          value={value.comune || ""}
          onChange={(e) => patch("comune", e.target.value)}
          className="mt-1 h-9 rounded-md border-slate-200 bg-white"
          placeholder="Milano"
          data-testid={`${testidPrefix}-comune`}
        />
      </div>
      <div className="sm:col-span-3">
        <Label className="text-xs font-medium text-slate-600">Provincia</Label>
        <Select
          value={value.provincia || ""}
          onValueChange={(v) => patch("provincia", v)}
        >
          <SelectTrigger
            className="mt-1 h-9 rounded-md border-slate-200 bg-white"
            data-testid={`${testidPrefix}-provincia`}
          >
            <SelectValue placeholder="—" />
          </SelectTrigger>
          <SelectContent className="max-h-72">
            {PROVINCE_IT.map((p) => (
              <SelectItem key={p.code} value={p.code}>
                {p.code} · {p.label}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      </div>
    </div>
  );
}
